import { createSlider, getObserver } from '@theme/theme-global';

if (!customElements.get('testimonials-cards')) {
  class TestimonialsCards extends HTMLDivElement {
    constructor() {
      super();
      this.section = this.closest('.shopify-section');
      this.params = JSON.parse(this.dataset.params);
      this.sliderInstance = null;
      this._observer = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    init() {
      const isFirstSection = this.section?.querySelector('[data-index]')?.dataset?.index === '1';
      const assignSlider = () => {
        if (this.sliderInstance || this._sliderInitializing) return;
        this._sliderInitializing = true;
        createSlider(this, this.params)
          .then((instance) => {
            this.sliderInstance = instance;
          })
          .finally(() => {
            this._sliderInitializing = false;
          });
      };

      if (isFirstSection) {
        assignSlider();
      } else if ('IntersectionObserver' in window) {
        this._observer = getObserver({ rootMargin: '300px 0px', threshold: 0 }, true, false);
        this._observer.observe(this, assignSlider);
      } else {
        assignSlider();
      }

      this.cardsHoverAnimation();
    }

    cardsHoverAnimation() {
      const cards = this.querySelectorAll('[data-item]');
      cards.forEach((card) => {
        let updateCall = null;
        let transitionTimeout = null;

        card.style.willChange = 'transform';
        card.style.transformOrigin = '50% 50%';

        card.addEventListener('mouseenter', () => {
          clearTimeout(transitionTimeout);
          // Enter animation transition
          card.style.transition = 'transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          // Remove transition after it completes so mouse tracking is instantaneous and doesn't shiver
          transitionTimeout = setTimeout(() => {
            card.style.transition = 'none';
          }, 200);
        });

        card.addEventListener('mousemove', (e) => {
          if (updateCall !== null) {
            cancelAnimationFrame(updateCall);
          }
          const rect = card.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;

          updateCall = requestAnimationFrame(() => {
            const centerX = rect.width / 2;
            const centerY = rect.height / 2;
            // Max rotation angle in degrees
            const maxTilt = 10;
            // Calculate rotation to push the card backward on hover
            const rotateX = ((y - centerY) / centerY) * -maxTilt;
            const rotateY = ((x - centerX) / centerX) * maxTilt;
            // Added slight scale (1.02) to keep edges under the mouse and prevent edge-slip flickering
            card.style.transform = `perspective(1500px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
          });
        });

        card.addEventListener('mouseleave', () => {
          if (updateCall !== null) {
            cancelAnimationFrame(updateCall);
          }
          clearTimeout(transitionTimeout);
          // Return to original state with smooth transition
          card.style.transition = 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          card.style.transform = `perspective(1500px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)`;
        });
      });
    }

    destroySlider() {
      if (this.sliderInstance?.destroy) {
        this.sliderInstance.destroy(true, true);
      }
      if (this._observer) {
        this._observer.unobserve(this);
        this._observer = null;
      }
      this.sliderInstance = null;
    }
  }
  customElements.define('testimonials-cards', TestimonialsCards, { extends: 'div' });
}
